import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
export const RETRY_BACKOFF_MS = 200;
// WHY jitter: a correlated upstream failure would otherwise send every browser's replays back in lockstep.
const jitteredRetryBackoffMs = (random)=>RETRY_BACKOFF_MS * (0.5 + random);
const RATE_LIMIT_JITTER_MS = 5000;
const RATE_LIMIT_MAX_REPLAYS = 2;
// WHY a ceiling: the gateway window is 60 s, and a wait past setTimeout's 2^31 ms limit would fire at once.
const RATE_LIMIT_MAX_WAIT_MS = 60000;
// WHY jitter on top of the gateway wait: the rate-limit window is fixed, so every tab's wait expires in the same second.
export const rateLimitRetryDelayMs = (retryAfterMs, random)=>Math.min(retryAfterMs !== null && retryAfterMs !== void 0 ? retryAfterMs : jitteredRetryBackoffMs(random), RATE_LIMIT_MAX_WAIT_MS) + RATE_LIMIT_JITTER_MS * random;
const replayDelayMs = (failure, retryAfterMs, replaysDone, random, param)=>{
    let { replaysGatewayFailures, replayRefusal } = param;
    var _replayRefusal_delaysMs_replaysDone;
    if (replayRefusal === null || replayRefusal === void 0 ? void 0 : replayRefusal.isReplayable(failure)) return (_replayRefusal_delaysMs_replaysDone = replayRefusal.delaysMs[replaysDone]) !== null && _replayRefusal_delaysMs_replaysDone !== void 0 ? _replayRefusal_delaysMs_replaysDone : null;
    if (!replaysGatewayFailures) return null;
    if (failure.status === 503 && replaysDone === 0) return jitteredRetryBackoffMs(random());
    if (failure.isTooManyAttemptsError() && replaysDone < RATE_LIMIT_MAX_REPLAYS) {
        return rateLimitRetryDelayMs(retryAfterMs, random());
    }
    return null;
};
const untilAborted = (signal)=>new Promise((resolve)=>{
        var _signal_addEventListener;
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) resolve();
        signal === null || signal === void 0 ? void 0 : (_signal_addEventListener = signal.addEventListener) === null || _signal_addEventListener === void 0 ? void 0 : _signal_addEventListener.call(signal, 'abort', ()=>resolve(), {
            once: true
        });
    });
export const sendWithReplays = (attempt, policy, param)=>{
    let { delay, random, getNow } = param;
    const send = (replaysDone, rateLimitSeen)=>attempt().then((response)=>{
            if (rateLimitSeen != null) {
                policy.onRateLimitRecovered({
                    attempts: replaysDone + 1,
                    retryAfterMs: rateLimitSeen.retryAfterMs
                });
            }
            return response;
        }, async (error)=>{
            var _ref;
            const failure = new ErrorResponse(error);
            const seen = failure.isTooManyAttemptsError() ? {
                retryAfterMs: failure.retryAfterMs(getNow().getTime())
            } : null;
            const waitMs = policy.canReplay() ? replayDelayMs(failure, (_ref = seen === null || seen === void 0 ? void 0 : seen.retryAfterMs) !== null && _ref !== void 0 ? _ref : null, replaysDone, random, policy) : null;
            if (waitMs == null) throw error;
            await Promise.race([
                delay(waitMs),
                untilAborted(policy.signal)
            ]);
            if (!policy.canReplay()) throw error;
            return send(replaysDone + 1, seen);
        });
    return send(0, null);
};
